import { ClinicalItemType } from '@/api/apis/case';
import { ClinicalItemLog } from '../types';
import { dispositionSpecificationNames } from '@/constants/case/case.constants';

export const getOrganApprovalMessage = (record: ClinicalItemLog<ClinicalItemType.OrganApproved>) => {
  return `by ${record.approverFirstName} ${record.approverLastName}`;
};

export const getOrganDeclineMessage = (record: ClinicalItemLog<ClinicalItemType.OrganDeclined>) => {
  return `by ${record.declinerFirstName} ${record.declinerLastName}${'\n'}Reason: ${dispositionSpecificationNames[record.reason]}`;
};
